import { useLastInteractedStore, useLastValidOrder } from '../../../../context';

// ─────────────────────────────────────────────────────────────────────────────

export const useProductDetailsLocation = () => {
  const lastInteractedStore = useLastInteractedStore();
  const lastValidOrder = useLastValidOrder();

  const isFetchingLastValidOrder = lastValidOrder.isFetchingOrders;

  return {
    lastInteractedStore,
    isFetching: isFetchingLastValidOrder,
  };
};
